import styled from 'styled-components';

const LandingFooterStyle = styled.div`
	--footerBorderRadius: var(--sp25x) var(--sp25x) 0 0;
	--footerPadding: var(--sp14x) 0;
	--errorExplain: 200%;
	--footerFormInput: var(--sp50x);
	--footerFormPadding: var(--sp2x) var(--sp3x);
	--footerFormMaxWidth: var(--sp77x);
	--formWrapMaxWidth: var(--sp86x);
	--footerFormMarginBottom: var(--sp6x);
	--socialItemMarginRight: var(--sp4x);
	--socialIconSize: var(--sp4x);
	--lowerFooterPaddingTop: var(--sp8x);
	--landingFooterContentMarginBottom: var(--sp13x);
	--landingFooterTextMarginBottom: var(--sp6x);
	--footerFormSuccessMessagePaddingLeft: var(--sp3x);
	--footerFormSuccessMessageMarginTop: var(--sp0-5x);

	border-radius: var(--footerBorderRadius);
	padding: var(--footerPadding);
	background-color: var(--secondaryColor4);

	.footer-form-success-message {
		position: absolute;
		top: 100%;
		left: 0;
		padding-left: var(--footerFormSuccessMessagePaddingLeft);
		margin-top: var(--footerFormSuccessMessageMarginTop);
	}

	.landing-footer-content-wrap {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		margin-bottom: var(--landingFooterContentMarginBottom);

		.form-wrap {
			position: relative;
			max-width: var(--formWrapMaxWidth);

			.subscribe-block-text {
				margin-bottom: var(--landingFooterTextMarginBottom);
			}

			.ant-form-item-explain {
				width: 100%;
				padding-left: unset;
				position: absolute;
				margin-top: var(--sp2x);
			}

			.footer-form-input {
				width: var(--footerFormInput);
			}

			.footer-form {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: var(--footerFormPadding);
				background-color: var(--primaryColor3);
				max-width: var(--footerFormMaxWidth);
				border-radius: var(--sp1x);

				&.sending {
					pointer-events: none;
				}

				.landing-footer-btn {
					button {
						span {
							font-size: var(--pS);
							font-family: var(--ping);
							font-weight: 600;
						}
					}
				}

				.ant-input {
					border: none;
					background-color: transparent;
					padding: unset;
				}

				.ant-form-item {
					margin: 0;
				}
			}
		}

		.subscribe-block-socials {
			.socials-item {
				margin-right: var(--socialItemMarginRight);

				.social-icon {
					transition: var(--trTime);
					font-size: var(--socialIconSize);

					@media (hover: hover) {
						&:hover {
							color: var(--primaryColor2);
						}
					}
				}

				&:last-child {
					margin-right: 0;
				}
			}
		}
	}

	.line {
		height: 1px;
		background-color: var(--secondaryColor2);
		opacity: 20%;
	}

	.lower-footer {
		padding-top: var(--lowerFooterPaddingTop);

		.copyright-wrap {
			display: flex;
		}

		.lower-footer-text-content-wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.made-by-wrap {
				display: flex;
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--footerBorderRadius: var(--sp25x) var(--sp25x) 0 0;
		--footerPadding: var(--sp10x) 0;
		--errorExplain: 170%;
		--footerFormInput: var(--sp35x);
		--footerFormPadding: var(--sp1-5x) var(--sp2x);
		--footerFormMaxWidth: var(--sp77x);
		--formWrapMaxWidth: var(--sp62x);
		--footerFormMarginBottom: var(--sp4x);
		--socialIconSize: var(--sp3x);
		--lowerFooterPaddingTop: var(--sp7x);
		--landingFooterContentMarginBottom: var(--sp11x);
		--landingFooterTextMarginBottom: var(--sp4x);
		--footerFormSuccessMessagePaddingLeft: var(--sp2x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--footerBorderRadius: var(--sp20x) var(--sp20x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--errorExplain: 170%;
		--footerFormInput: var(--sp26x);
		--footerFormPadding: var(--sp1-5x) var(--sp2x);
		--footerFormMaxWidth: var(--sp45x);
		--formWrapMaxWidth: var(--sp50x);
		--footerFormMarginBottom: var(--sp3x);
		--socialIconSize: var(--sp3x);
		--lowerFooterPaddingTop: var(--sp3x);
		--landingFooterContentMarginBottom: var(--sp8x);
		--landingFooterTextMarginBottom: var(--sp3x);
		--footerFormSuccessMessagePaddingLeft: var(--sp2x);
		--footerFormSuccessMessageMarginTop: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--footerBorderRadius: var(--sp20x) var(--sp20x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--errorExplain: 150%;
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerFormMaxWidth: var(--sp45x);
		--formWrapMaxWidth: var(--sp48x);
		--footerFormMarginBottom: var(--sp3x);
		--socialIconSize: var(--sp3x);
		--lowerFooterPaddingTop: var(--sp3x);
		--landingFooterContentMarginBottom: var(--sp8x);
		--landingFooterTextMarginBottom: var(--sp3x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--footerBorderRadius: var(--sp14x) var(--sp14x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--errorExplain: 150%;
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerFormMaxWidth: var(--sp45x);
		--formWrapMaxWidth: var(--sp48x);
		--footerFormMarginBottom: var(--sp3x);
		--socialIconSize: var(--sp3x);
		--lowerFooterPaddingTop: var(--sp3x);
		--landingFooterContentMarginBottom: var(--sp8x);
		--landingFooterTextMarginBottom: var(--sp3x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--footerBorderRadius: var(--sp17x) var(--sp17x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--errorExplain: 150%;
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerFormMaxWidth: var(--sp45x);
		--formWrapMaxWidth: var(--sp52x);
		--footerFormMarginBottom: var(--sp3x);
		--socialIconSize: var(--sp3x);
		--lowerFooterPaddingTop: var(--sp3x);
		--landingFooterContentMarginBottom: var(--sp8x);
		--landingFooterTextMarginBottom: var(--sp3x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--footerBorderRadius: var(--sp17x) var(--sp17x) 0 0;
		--footerPadding: var(--sp8x) 0;
		--errorExplain: 150%;
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerFormMaxWidth: var(--sp45x);
		--formWrapMaxWidth: var(--sp43x);
		--footerFormMarginBottom: var(--sp3x);
		--socialIconSize: var(--sp3x);
		--lowerFooterPaddingTop: var(--sp3x);
		--landingFooterContentMarginBottom: var(--sp8x);
		--landingFooterTextMarginBottom: var(--sp3x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);

		.landing-footer-content-wrap {
			flex-direction: column;
			align-items: unset;

			.subscribe-block-socials {
				margin-top: var(--sp5x);
			}
		}
		.lower-footer {
			.lower-footer-text-content-wrap {
				flex-direction: column;
				align-items: flex-start;

				.made-by-wrap {
					margin-top: var(--sp3x);
				}
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--footerBorderRadius: var(--sp8x) var(--sp8x) 0 0;
		--footerPadding: var(--sp7x) 0;
		--errorExplain: 150%;
		--footerFormInput: var(--sp25x);
		--footerFormPadding: var(--sp1x) var(--sp1-5x);
		--footerFormMaxWidth: 100%;
		--formWrapMaxWidth: 100%;
		--footerFormMarginBottom: var(--sp3x);
		--socialIconSize: var(--sp3x);
		--lowerFooterPaddingTop: var(--sp3x);
		--landingFooterContentMarginBottom: var(--sp8x);
		--landingFooterTextMarginBottom: var(--sp3x);
		--footerFormSuccessMessagePaddingLeft: var(--sp1-5x);
		--footerFormSuccessMessageMarginTop: var(--sp1x);

		.landing-footer-content-wrap {
			flex-direction: column;
			align-items: unset;

			.subscribe-block-socials {
				margin-top: var(--sp5x);
			}
		}

		.lower-footer {
			.lower-footer-text-content-wrap {
				flex-direction: column;
				align-items: flex-start;

				.made-by-wrap {
					margin-top: var(--sp3x);
				}
			}
		}
	}
`;

export default LandingFooterStyle;
